import { render, staticRenderFns } from "./ActionsMagazine.vue?vue&type=template&id=c37deace&"
import script from "./ActionsMagazine.vue?vue&type=script&lang=js&"
export * from "./ActionsMagazine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports